module.exports = __webpack_public_path__ + "static/media/phone.4505cf50.svg";